module.exports = __webpack_public_path__ + "static/img/an1-mayor.fdf92a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/an1-mayor.png
// module id = Yvei
// module chunks = 0